import * as CONSTANTS from "../../Constants/index"

export type PaginationState = {
  skip: number,
  queryPageIndex: number,
  queryPageSize: number,
  totalCount: number,
  navigation: {
    from: number,
    to: number
  },
  pageNavigationDirection: "next" | "previous"
};

export type PaginationAction = {
  type: "PAGE_CHANGED" | "TOTAL_COUNT_CHANGED" | "SEARCH_PAGE_RESET" | "PAGE_INITIAL_STATE" | "",
  payload: number
};

export const initialState: PaginationState = {
  skip: 0,
  queryPageIndex: 1,
  queryPageSize: 10,
  totalCount: 0,
  navigation: {
    from: 1,
    to: 1
  },
  pageNavigationDirection: "next"
};

const navigationDirection = (
  state: Readonly<Pick<PaginationState, "pageNavigationDirection" | "queryPageIndex" | "totalCount" | "queryPageSize">>, 
  action: Readonly<Pick<PaginationAction, "payload">>
): "next" | "previous" => {
  const lastPage: number = Math.ceil(state.totalCount / state.queryPageSize);

  if (Math.abs(state.queryPageIndex - action.payload) === 1) {  
    return state.pageNavigationDirection;
  }

  if (action.payload === 1) {
    return "next";
  }

  if (action.payload === lastPage) {
    return "previous";
  } 

  return state.pageNavigationDirection;
};

export const reducer = (state: PaginationState, action: PaginationAction): PaginationState => {

  switch (action.type) {
    case CONSTANTS.PAGE_CHANGED:
      {
        const skip = (action.payload - 1) * state.queryPageSize;
        return {
          skip: skip,
          queryPageIndex: action.payload,
          queryPageSize: state.queryPageSize,
          totalCount: state.totalCount,
          navigation: {
            from: state.queryPageIndex,
            to: action.payload
          },
          pageNavigationDirection: navigationDirection(state, action)
        };
      }

    case CONSTANTS.TOTAL_COUNT_CHANGED:
      {
        let lastIndex = Math.ceil(action.payload / state.queryPageSize);
        let queryPageIndex = state.queryPageIndex > lastIndex ? lastIndex : state.queryPageIndex;
        let skip = (queryPageIndex - 1) * state.queryPageSize;
        return {
          skip: skip,
          queryPageIndex: queryPageIndex,
          queryPageSize: state.queryPageSize,
          totalCount: action.payload,
          navigation: {
            from: state.queryPageIndex,
            to: action.payload
          },
          pageNavigationDirection: navigationDirection(state, action)
        };
      }

    case CONSTANTS.SEARCH_PAGE_RESET:
      return {
        skip: 0,
        queryPageIndex: 1, 
        queryPageSize: state.queryPageSize,
        totalCount: action.payload,
        navigation: {
          from: state.queryPageIndex,
          to: action.payload
        },
        pageNavigationDirection: "next"
      };

    case CONSTANTS.PAGE_INITIAL_STATE:
      return {
        ...initialState
      };

    default:
      return state;
  }
}